/**
 * @generated SignedSource<<7cd0f1b39bf0bf7af926f293576ee398>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ProjectNoteUpdateInput = {
  id: number;
  note: string;
};
export type NoteUpdateMutation$variables = {
  note: ProjectNoteUpdateInput;
};
export type NoteUpdateMutation$data = {
  readonly action_project_note_update: {
    readonly note: {
      readonly created_by: string | null | undefined;
      readonly creator_email: string | null | undefined;
      readonly id: number;
      readonly note: string;
      readonly updated_at: string;
    } | null | undefined;
    readonly user_id: number;
  };
};
export type NoteUpdateMutation = {
  response: NoteUpdateMutation$data;
  variables: NoteUpdateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "note"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "note"
      }
    ],
    "concreteType": "ProjectNoteUpdateOutput",
    "kind": "LinkedField",
    "name": "action_project_note_update",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "notes",
        "kind": "LinkedField",
        "name": "note",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "note",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "created_by",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "creator_email",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updated_at",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "user_id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "NoteUpdateMutation",
    "selections": (v1/*: any*/),
    "type": "mutation_root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "NoteUpdateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "f500a12629daee82da73d28973014952",
    "id": null,
    "metadata": {},
    "name": "NoteUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation NoteUpdateMutation(\n  $note: ProjectNoteUpdateInput!\n) {\n  action_project_note_update(input: $note) {\n    note {\n      id\n      note\n      created_by\n      creator_email\n      updated_at\n    }\n    user_id\n  }\n}\n"
  }
};
})();

(node as any).hash = "4671cb1f260f4d04e7006377272f18da";

export default node;
